<template>
    <transition name="modal-fade">
        <div class="modal-overlay" @click="$emit('close-modal')"  :style="{ 'margin-left': sidebarWidth }">
            <div class="modal-content " @click.stop>

                <div class="bg">

                    <div class="invisible_button" @click="$emit('close-modal')"></div>
                </div>
                 
            </div>
            
        </div>
    </transition>

</template>

<script>
    import { sidebarWidth } from '../siderbar/state';
  
    export default {
        setup() {
            return { sidebarWidth }
        },
      
    }
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: left;
        background-color: #00000088;
        width:100vw;

    }

    .modal-content {
        display: table;
        justify-content: right;
        clear: both;
        overflow: hidden;
        background-color: transparent !important;
        border: none;
        max-width: 680px;
    }

    @media screen and (min-width: 920px) {
        .modal-content {
            max-width: 680px;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 919px) {
        .modal-content {
            max-width: calc(100% - 250px);
        }
    }
    @media screen and (min-width: 540px) and (max-width: 767px) {
        .modal-content {
            max-width: calc(100% - 100px);
        }
    }
    @media screen and  (max-width: 539px) {
        .modal-content {
            max-width: 90%;
            text-align:center;
           margin-left:4%;
           
        }
        .bg{margin-top: 210px !important; margin-right:24px;}
     
    }

    .bg {
        background-image: url('../../assets/images/project_interaction.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        height: 400px;
        width: 300px;
        max-width: 80%;
        margin-top: 220px;
        float: right;
    }

    .invisible_button{ width: 80px; height: 30px; margin:330px auto 0px auto; cursor:pointer;}


    .check {
        width: 150px;
    }

    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }
</style>